import React, {Component, Fragment} from "react";
import { connect } from "react-redux";
import DispatchProps from "../../../utils/DispatchProps";
import { IRootState } from "../../../store";
import ApiService from "../../ApiService";
import { SchoolWorkloadConfig, sortYearGroupingsByIsAfterValues, YearGrouping } from "../../../models/SchoolWorkloadConfig";
import SdsYear from "../../../models/SdsYear";
import AssignYearsEditor from "../../AssignYearsEditor";
import HelpBox from "./HelpBox";
import { MessageBarType, PrimaryButton } from "office-ui-fabric-react/lib-commonjs";
import * as _ from "lodash";
import Actions from "../../../redux/Actions";
import SchoolPageTitle from "../../SchoolPageTitle";
import AdminSchoolMenu from "../../AdminSchoolMenu";

interface ConfigureAssignYearsProps {
    tenantId: string;
    schoolCode: string;
    apiService: ApiService;
}

interface ConfigureAssignYearsState {
    schoolWorkloadConfig?: SchoolWorkloadConfig;
    sdsYears?: SdsYear[];
    yearGroupingItems: YearGrouping[];
}

class ConfigureAssignYearsPage extends Component<ConfigureAssignYearsProps & DispatchProps, ConfigureAssignYearsState>{

    constructor(props: ConfigureAssignYearsProps & DispatchProps) {
        super(props);
        this.state = {
            schoolWorkloadConfig: undefined,
            sdsYears: [],
            yearGroupingItems: [] 
        }; 
    }

    async componentDidMount(): Promise<void> {
        if (this.props.tenantId) {
            this.loadState();
        }
    }

    async componentDidUpdate(prevProps: ConfigureAssignYearsProps & DispatchProps, prevState: any) {

        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            this.loadState();
        }

    }

    private async loadState() {
        const schoolWorkloadConfig = await this.props.apiService.getSchoolConfigJson(this.props.tenantId, this.props.schoolCode);

        const sdsYears = await this.props.apiService.getSdsYearsForSchool(this.props.tenantId, this.props.schoolCode);

        this.setState({
            schoolWorkloadConfig, 
            sdsYears,
            yearGroupingItems: sortYearGroupingsByIsAfterValues(schoolWorkloadConfig.yearGroupings.items!)
        });
    }

    private save = async () => {
        if (this.state.schoolWorkloadConfig === undefined) {
            console.log("Config cannot be found");
            return;
        }

        const updatedConfig = _.cloneDeep(this.state.schoolWorkloadConfig);

        updatedConfig.yearGroupings.items = this.state.yearGroupingItems

        try {
            const savedSchoolWorkloadConfig = await this.props.apiService.putSchoolConfigJson(this.props.tenantId, this.props.schoolCode, updatedConfig);
            this.setState({ schoolWorkloadConfig: savedSchoolWorkloadConfig });

            this.props.dispatch(Actions.showMessageBar("Saved year groupings to config", MessageBarType.success));

        } catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Error saving config: ${e}`, MessageBarType.error));
        }
    }

    public render(): JSX.Element {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Assign Years" />

                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />

                <HelpBox Icon={"DependencyAdd"} TitleText={"Assign Years"} HelpBoxText={"Use this page to assign years at this school"} /> 

                <div className="flex-column flex--align-items-center">
                    
                <AssignYearsEditor
                    tenantId={this.props.tenantId}
                    schoolCode={this.props.schoolCode}
                    sdsYears={this.state.sdsYears ? this.state.sdsYears : []}
                    yearGroupingItems={this.state.yearGroupingItems ? this.state.yearGroupingItems : []}
                    onYearGroupingChange={(yearGroups: YearGrouping[]) => { this.setState({ yearGroupingItems: yearGroups }) }} />

                </div>

                <div className="flex--item--flex-2 flex-row flex--justify-content-center p-1rem">
                    <PrimaryButton
                        text="Save"
                        onClick={() => { this.save() }}
                        style={{margin: 'auto'}}
                    />
                </div>

                

            </Fragment>
        );
        
    }
}

export default connect(
    (state: IRootState, ownProps: any): ConfigureAssignYearsProps => {
        return {
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
            apiService: state.auth.apiService
        }
    }
)(ConfigureAssignYearsPage)